import React, { Component } from 'react';
import Slider from 'react-slick';
import 'whatwg-fetch';

class RightNavButton extends Component {
  render() {
		return <button type="button" className="slick-next" {...this.props}><div className="slick-cap" >Next</div></button>
  }
}
class LeftNavButton extends Component {
  render() {
		return <button type="button" className="slick-prev" {...this.props}><div className="slick-cap">Previous</div></button>
  }
}

class Insider extends Component {
	constructor(){
		super();
		this.state = {
			insiders:[]
		}
		this.getInsider = this.getInsider.bind(this);
	}
	
	componentDidMount(){
		this.getInsider();
	}
	
	getInsider(){
		const { authors } = this.props;
		
		let that = this;
		let params = {
				ids:authors
			};
		let formData = new FormData();
		for (var k in params) {
			if(params.hasOwnProperty(k)){
				formData.append(k, params[k]);
			}
		}
		
		fetch('/wp-json/she-rest-api/getAuthors/',{
			method:"POST",
			body:formData
			}).then(function(res){ 
				return res.json(); 
			})
			.then(function(response){
				let arr = response;
				that.setState({ insiders:arr });
				
			}).catch(function(error){
				 console.log(error);
			});
	}
	
	render(){
		const { insiders } = this.state;
		
		if(insiders.length){
			let settings = {
                infinite: false,
                slidesToShow: 8,
                slidesToScroll: 8,
				prevArrow: <LeftNavButton/>,
				nextArrow: <RightNavButton/>,
				responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ]
			};
			return (
				<div>
					<Slider {...settings} >
					{
						insiders.map(function(item,index){
							return (
								<div key={index} className="love-insider">
									<div className="pic text-center">
										<a href={ item.url }>
											<img src={ item.thumbnail } border="0"/>
										</a>
									</div>
									<div className="Abel text-center author-name">{ item.display_name }</div>
									<div className="Abel text-center author-title">{ item.author_title }</div>
									<div className="Abel text-center author-from">{ item.author_from }</div>
								</div>
							)
						})
					}
					</Slider>
				</div>
			)
		}else{
			return <div></div>;
		}
	}
}

export default Insider


// WEBPACK FOOTER //
// ./src/Insider.js